<!-- 课程开班统计 -->
<template>
  <div>
    <div class="index" v-show="!detail.show">
      <div class="title">
        <div class="span1">
          <span>{{$route.name}}</span>
        </div>
        <p style="color:#606266;font-size:14px;">样例</p>
      </div>

      <!-- <header>
        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>课程开班统计</span>
          </div>
          <div id="echarts-box1"></div>
        </div>

        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>课程开班数TOP5</span>
          </div>
           <p class="header-item-text" style="margin-bottom:25px" ></p>
          <div id="echarts-box2"></div>
        </div>

        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>课程报名率TOP5</span>
          </div>
         
          <div id="echarts-box3"></div>
        </div>
      </header> -->

      <div>
        <el-form :inline="true" :model="queryParams" label-width="70px">
          <el-form-item label="">
            <el-select
              v-model="queryParams.value1"
              clearable
              placeholder="选择学年学期"
              class="label"
            >
              <el-option
                v-for="item in list1"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select
              v-model="queryParams.value2"
              clearable
              placeholder="课程分类"
              class="label"
            >
              <el-option
                v-for="item in list2"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input
              v-model="queryParams.name"
              placeholder="请输入课程名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="" style="margin-left: 20px">
            <el-button type="primary" size="small" @click="searchFun()"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>

        <div class="table">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="className" label="课程名称" align="center">
            </el-table-column>
            <el-table-column
              prop="classStudentNum"
              label="课程分类"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="signNum" label="课时总数" align="center">
            </el-table-column>
            <el-table-column
              prop="needAttendanceNum"
              label="招生人数"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="lateNum" label="报名人数" align="center">
            </el-table-column>
            <el-table-column prop="leaveNum" label="报名率" align="center">
            </el-table-column>
            <el-table-column
              prop="attendanceNum"
              label="开班总数"
              align="center"
            >
            </el-table-column>
    
            <el-table-column
              header-align="center"
              align="center"
              label="操作"
              width="200"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="toDetail(scope.row)"
                  >查看详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              background
              :current-page="pageNum"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              :total="totalPage"
              layout="total,prev, pager, next,jumper,sizes"
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <Detail
      :info="detail.info"
      v-show="detail.show"
      @to-index="toIndex"
    ></Detail>
  </div>
</template>
<script>
import api from "@/api/wisdomSchool/index.js";
import dayjs from "dayjs";
import * as echarts from "echarts";
export default {
  components: {
    Detail: () => import("./detail.vue"),
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      totalPage: 10,
      queryParams: {
         value1: "",
         value2: "",
      },
      sourceList: [],
      semesterList: [],
      teacherList: [],
      tableData: [ 
          {className:'科技编程	',    classStudentNum: "兴趣小组",signNum: "30",needAttendanceNum: "35",lateNum: 33,leaveNum: '94.29%', attendanceNum: 	1},
           {className:'酷酷机器人	',classStudentNum: "社团活动",signNum: "30",needAttendanceNum: "50",lateNum: 47,leaveNum: '94.00%', attendanceNum: 	8},
           {className:'幸福劳动	',    classStudentNum: "劳动	",signNum: "50",needAttendanceNum: "50",lateNum: 45,leaveNum: '90.00%', attendanceNum: 	8},
           {className:'博学书法	',    classStudentNum: "文体	",signNum: "50",needAttendanceNum: "50",lateNum: 42,leaveNum: '84.00%', attendanceNum: 	5},
           {className:'美学鉴赏课	',classStudentNum: "艺术	",signNum: "50",needAttendanceNum: "50",lateNum: 41,leaveNum: '82.00%', attendanceNum: 	4},
           {className:'温暖美术	',    classStudentNum: "艺术	",signNum: "50",needAttendanceNum: "50",lateNum: 40,leaveNum: '80.00%', attendanceNum: 	6},
           {className:'世界百科课	',classStudentNum: "科普	",signNum: "30",needAttendanceNum: "30",lateNum: 24,leaveNum: '80.00%', attendanceNum: 	3},
           {className:'海滨少儿美术', classStudentNum: "艺术	",signNum: "50",needAttendanceNum: "50",lateNum: 39,leaveNum: '78.00%', attendanceNum: 	9},
           {className:'竞技篮球	',    classStudentNum: "文体	",signNum: "50",needAttendanceNum: "50",lateNum: 37,leaveNum: '74.00%', attendanceNum: 	8},
           {className:'优美声乐	',    classStudentNum: "文体	",signNum: "30",needAttendanceNum: "30",lateNum: 22,leaveNum: '73.33%', attendanceNum: 	8}, 
           ],
       list1:[
				{id:"1",label:"2021~2022年度下学期	  ",  value:"1"},
				{id:"2",label:"2021~2022年度上学期	 ",value:"2"},
				{id:"3",label:"2020~2021年度下学期	 ",  value:"3"},
				{id:"4",label:"2020~2021年度上学期	 ",value:"4"},
				{id:"5",label:"2019~2020年度下学期	 ",  value:"5"},
				{id:"6",label:"2019~2020年度上学期	  ",value:"6"},
			],
       list2:[
				{id:"1",label:"科技编程	  ",  value:"1"},
				{id:"2",label:"酷酷机器人 ",value:"2"},
				{id:"3",label:"幸福劳动 ",  value:"3"},
				{id:"4",label:"博学书法 ",value:"4"},
				{id:"5",label:"美学鉴赏课 ",  value:"5"},
				{id:"6",label:"温暖美术  ",value:"6"},
				{id:"7",label:"世界百科课 ",  value:"7"},
				{id:"8",label:"海滨少儿美术 ",value:"8"},
				{id:"9",label:"竞技篮球 ",  value:"9"},
				{id:"10",label:"优美声乐  ",value:"10"},
			],
      detail: {
        info: {},
        show: false,
      },
      school_info: JSON.parse(sessionStorage.getItem("classList")),
      semesterArr: JSON.parse(sessionStorage.getItem("semesterList")),
    };
  },
  watch: {
    "queryParams.source": function (n, o) {
      this.queryParams.teacher = "";
      this.teacherList = [];
      // this.gradeList = this.campusList.filter((v) => v.id === n)[0]?.children || [];
    },
  },
  mounted() {
    // this.semesterList = this.semesterArr.map((v) => ({
    //   label: v.schoolYear + "第" + v.semester + "学期",
    //   id: v.schoolYear + "_" + v.semester,
    // }));
    // this.getDataList(); 
    //  this.init();   
  },
  created() {

  },
  methods: {
    async getDataList() {
      let start = "",
        end = "";
      let params = {
        schoolYearSemester: this.queryParams.semester,
        startDate: start,
        endDate: end,
        campusId:this.queryParams.campus,
        gradeId: this.queryParams.grade,
        classId: this.queryParams.class,
        orgId: sessionStorage.getItem("orgId"),
        platformCode: sessionStorage.getItem("platformCode"),
        page: this.pageNum,
        limit: this.pageSize,
      };
      this.tableData=[]
          
    },
    searchFun() {
      this.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList();
    },
    toDetail(item) {
      this.detail.info = item;
      this.detail.show = true;
    },
    toIndex() {
      this.detail.show = false;
    },
    init(){
      let vm = this;
      this.$nextTick(() => {
        // 圆环图
        let chartDom1 = document.getElementById('echarts-box1');
        let myChart1 = echarts.init(chartDom1);
        let option1 = {
          legend: {
            // data: [],
            // orient: 'vertical',
            left: 'center',
            top: 'bottom',
            icon : 'circle',
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['38%', '50%'], // 这个属性修改环形宽度
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 0,
                borderColor: '#fff',
                borderWidth: 0,
              },
              label: {
                show: false,
                position: 'center',
              },
              emphasis: {
                label: {
                  show: false,
                  fontSize: '16',
                  fontWeight: 'bold',
                },
              },
              labelLine: {
                show: false,
              },
              data: [
                { value: 60, name: '作业辅导' },
                { value: 58, name: '科普' },
                { value: 32, name: '文体' },
                { value: 30, name: '艺术' },
                { value: 28, name: '劳动' },
                { value: 28, name: '阅读' },
                { value: 28, name: '其它' },
              ],
            },
          ],
          // 圆环颜色
          color: [ '#51D6A6', '#5BB0FF', '#757FFD','#D375FD', '#F27676', '#F49562', '#7CE064'],
        };
        myChart1.setOption(option1);

        // 柱状图
        let chartDom2 = document.getElementById('echarts-box2');
        let myChart2 = echarts.init(chartDom2);
        let option2 = {
          tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(0, 0, 0, .6)', //通过设置rgba调节背景颜色与透明度
            borderWidth: '0',
            textStyle: {
              color: 'white',
              fontSize: '12',
            },
            formatter: function (params, ticket, callback) {
              return "<span style='font-size: 26px;line-height: 30px;'>" + params.value + '</span>' + '<br />' + "<span style='font-size:14px;line-height: 18px;'>" + params.name + '</span>';
            },
          },
          grid: {
            height: 200,
            top: 30,
            left: 42,
          },
          xAxis: {
            type: 'category',
            data: ['科技\n编程', '酷酷\n机器\n人', '幸福\n劳动·', '温暖\n美术', '博学\n书法'],
            // splitLine: {show: false},//去除网格分割线
            axisLine: {
              //坐标线
              lineStyle: {
                type: 'solid',
                color: '#DDDDDD', //轴线的颜色
                width: '1', //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: '#999999', //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              data: [10, 10, 8, 6, 5],
              type: 'bar',
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: 'none', //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    // { offset: 0, color: '#009DFD' },
                    { offset: 1, color: '#5BB0FF' },
                  ]),
                  // barBorderRadius: 16, // 柱子圆角, 单位为px
                },
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart2.setOption(option2);

        // 柱状图
        let chartDom3 = document.getElementById('echarts-box3');
        let myChart3 = echarts.init(chartDom3);
        let option3 = {
          tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(0, 0, 0, .6)', //通过设置rgba调节背景颜色与透明度
            borderWidth: '0',
            textStyle: {
              color: 'white',
              fontSize: '12',
            },
            formatter: function (params, ticket, callback) {
              return "<span style='font-size: 26px;line-height: 30px;'>" + params.value + '</span>' + '<br />' + "<span style='font-size:14px;line-height: 18px;'>" + params.name + '</span>';
            },
          },
          grid: {
            height: 200,
            top: 30,
            left: 42,
          },
          xAxis: {
            type: 'category',
            data: ['科技\n编程', '酷酷\n机器\n人', '幸福\n劳动', '温暖\n美术', '博学\n书法'],
            axisLine: {
              //坐标线
              lineStyle: {
                type: 'solid',
                color: '#DDDDDD', //轴线的颜色
                width: '1', //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: '#999999', //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              data: [94.29, 94.00, 90.00, 84.00, 82.00],
              type: 'bar',
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: 'none', //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 1, color: '#51D6A6' },
                  ]),
                },
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart3.setOption(option3);
      });
    },
  },
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .title {
    height: 60px;
    line-height: 48px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    .span1 {
      font-family: "PingFang SC Bold";
      font-weight: bold;
      font-size: 20px;
      text-align: left;
      color: #000;
      margin-right: 30px;
    }
  }

  ::v-deep .el-form .el-input__inner {
    // width: 150px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
header{
  width: 100%;
  height: 350px;
  display: flex;
  .header-item{
    width: 33%;
    .header-item-title{
      font-size: 18px;
      color: #333;
      display: flex;
      align-items: center;
      .circle{
        width: 8px;
        height: 8px;
        display: inline-block;
        background: #4991e1;
        border-radius: 50%;
        margin-right: 10px;
      }
    }
    .header-item-text{
      font-size: 14px;
      color: #666;
      padding-left: 20px;
      margin-top: 5px;
    }
  }
  #echarts-box1{
    width:280px;
    height:280px;
  }
  #echarts-box2,#echarts-box3{
    width:300px;
    height:280px;
  }
  #echarts-box3{
    margin-top: 25px;
  }
}
</style>
